import { INIT_CALCULATOR } from 'apps/auth/actions/calculatorAction';
import update from 'immutability-helper';

const calculator = (state = {}, action) => {
    let mergeState;
    const data = action.data;
    switch (action.type) {
        case INIT_CALCULATOR:
            mergeState = update(state, {
                paymentForm: { $set: data.paymentForm },
                paymentInfo: { $set: data.paymentInfo },
                countryMenu: { $set: data.countryMenu },
                countryTo: { $set: data.countryTo },
                countryFrom: { $set: data.countryFrom },
                commission: { $set: data.commission },
                requestForm: { $set: data.requestForm },
            });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default calculator;
